export default {
  INCORRECT_DEPOSIT_AMOUNTS: 'INCORRECT_DEPOSIT_AMOUNTS',
  ACCOUNTS_LIMIT: 'ACCOUNTS_LIMIT',
  ADDITION_LIMIT: 'ADDITION_LIMIT',
  AUTH_LIMIT: 'AUTH_LIMIT',
  IDENTITY_LIMIT: 'IDENTITY_LIMIT',
  INCOME_LIMIT: 'INCOME_LIMIT',
  ITEM_GET_LIMIT: 'ITEM_GET_LIMIT',
  RATE_LIMIT: 'RATE_LIMIT',
  TRANSACTIONS_LIMIT: 'TRANSACTIONS_LIMIT',
  TOO_MANY_VERIFICATION_ATTEMPTS: 'TOO_MANY_VERIFICATION_ATTEMPTS',
};
